import { Typography } from "@/components/shared/typography";
import { View, Image } from "@/components/ui";
import type { CreditAccountType } from "@/types/profile";
import { InfoHelper } from "./info-helper";
import { getCreditAccountBannerIcon } from "../utils";

export const CreditAccountBanner = ({
  children,
  balance,
  icon,
}: {
  children?: React.ReactElement;
  balance: string;
  icon?: CreditAccountType;
}) => {
  const isGeneralCreditAccount = icon === "general";
  const iconSrc = getCreditAccountBannerIcon(icon);

  return (
    <View className="mx-4 rounded-2xl bg-[url(@/assets/images/credit-overview-card-background.png)] bg-cover p-4 md:mx-0 md:p-6">
      <View className="flex flex-col items-center gap-2 pb-2 pt-6">
        {icon && (
          <Image
            src={iconSrc}
            alt={`${icon} credit account icon`}
            className="size-10 md:size-12"
            width={32}
            height={32}
          />
        )}
        <View className="flex w-full flex-1 flex-row items-center justify-center gap-1">
          <Typography variant="body-sm">Total Balance</Typography>
          {icon && isGeneralCreditAccount && <InfoHelper />}
        </View>
        <Typography variant="h1" color="brand-static">
          ${balance}
        </Typography>
      </View>
      {children}
    </View>
  );
};
